export default __webpack_public_path__ + "static/media/the-villa8.89517cba.webp";